import { relativePath } from '@/functions/redirectToRelativePath';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';

type Props = {
  categories: CategoryDto[];
  customerSetting: CustomerSetting;
};

export const RelatedCategories: React.FC<Props> = ({
  categories,
  customerSetting
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        flexWrap: 'wrap'
      }}
    >
      {categories.map((category) => {
        return (
          <Button
            key={`related-category-${category.id}`}
            variant="outlined"
            size="small"
            sx={{
              borderRadius: 5,
              fontSize: theme.typography.caption.fontSize
            }}
            href={relativePath(
              `/list/?category=${category.id}#events`,
              customerSetting.domain
            )}
          >
            {category.name}
          </Button>
        );
      })}
    </Box>
  );
};
